export default "__VITE_ASSET__PcRgq3HK__"